module.exports = __webpack_public_path__ + "static/media/email.d40c154d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/email.svg
// module id = 256
// module chunks = 0